<template>
  <div class="p-4">
    <div class="mb-4">
      <h4>Service Tokens</h4>
      <p class="text-muted mb-0">
        Revoke the static service tokens held by outside-agent integrations. A new integration
        gets a <code>client_credentials</code> OAuth client with a service role instead.
      </p>
    </div>

    <div class="d-flex flex-wrap" style="gap: 1.5rem;">
      <!-- Revoke all tokens card -->
      <b-card title="Revoke all tokens" style="max-width: 480px; flex: 1 1 400px;">
        <p class="mb-3">
          Immediately invalidates <strong>every</strong> previously minted service token.
          Any integration using an old token will stop working right away. This cannot be
          undone.
        </p>
        <b-button variant="danger" :disabled="isLoading" @click="handleRevokeAllTokens">
          <i class="fa fa-ban mr-1"></i> Revoke all tokens
        </b-button>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('serviceTokens', ['isLoading']),
  },
  methods: {
    ...mapActions('serviceTokens', ['revokeAllTokens']),
    async handleRevokeAllTokens() {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        'Are you sure you want to revoke ALL service tokens? Every previously minted token ' +
          'will stop working immediately, including any in active use. This cannot be undone.',
        {
          title: 'Confirm revoke all tokens',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Revoke all',
          cancelTitle: 'Cancel',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        }
      )

      if (!confirmed) {
        return
      }

      try {
        await this.revokeAllTokens()
        this.$toasted.show('All service tokens revoked successfully!', {
          type: 'success',
          duration: 3000,
        })
      } catch (err) {
        console.error(err)
        this.$toasted.show('Failed to revoke service tokens', {
          type: 'error',
          duration: 3000,
        })
      }
    },
  },
}
</script>
